import { render, staticRenderFns } from "./ReleaseNote.vue?vue&type=template&id=b10c52dc&scoped=true"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNote.vue?vue&type=style&index=0&id=b10c52dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c52dc",
  null
  
)

export default component.exports